/**
 * Widget-Editor — Schritt-Navigation. 6 Schritte, FREI anwaehlbar (kein Wizard-Zwang: alle
 * sind jederzeit direkt erreichbar, Auto-Save haelt Zwischenstaende ohnehin fest).
 *
 * Desktop (lg+): linke Sidebar, vertikal. Mobile: horizontale Scroll-Pillen-Leiste, sticky direkt
 * unter dem Seiten-Kopf (Bauplan: "Mobile: horizontale Scroll-Pillen-Leiste, sticky unter Header").
 */
import { Icon } from "../../ui/components";

export type StepKey = "content" | "fields" | "ablauf" | "privacy" | "aussehen" | "embed";

export interface StepDef {
  key: StepKey;
  label: string;
  icon: string;
}

export const STEPS: StepDef[] = [
  { key: "content", label: "Inhalt", icon: "edit_note" },
  { key: "fields", label: "Felder", icon: "checklist" },
  { key: "ablauf", label: "Ablauf", icon: "route" },
  { key: "privacy", label: "Datenschutz", icon: "privacy_tip" },
  { key: "aussehen", label: "Aussehen", icon: "palette" },
  { key: "embed", label: "Einbinden", icon: "code" },
];

export function StepNav({ active, onSelect }: { active: StepKey; onSelect: (step: StepKey) => void }) {
  return (
    <>
      {/* Mobile: sticky Pillen-Leiste. `top-0` reicht hier, da die AppShell ihren eigenen
          Topbar-Sticky-Kontext hat -- die Leiste rutscht direkt darunter fest. */}
      <div className="sticky top-0 z-10 -mx-4 mb-4 overflow-x-auto border-b border-outline-variant/30 bg-surface-container-lowest px-4 py-2 dark:border-outline/30 dark:bg-night-card lg:hidden">
        <div className="flex gap-2">
          {STEPS.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onSelect(s.key)}
              className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 font-label-md text-label-md font-semibold transition-colors ${
                active === s.key
                  ? "bg-primary text-on-primary"
                  : "bg-surface-container-high text-on-surface-variant dark:bg-white/[0.06]"
              }`}
            >
              <Icon name={s.icon} className="text-[16px]" />
              {s.label}
            </button>
          ))}
        </div>
      </div>

      {/* Desktop: vertikale Sidebar. */}
      <nav className="hidden lg:block">
        <ul className="space-y-1">
          {STEPS.map((s) => (
            <li key={s.key}>
              <button
                type="button"
                onClick={() => onSelect(s.key)}
                className={`flex w-full items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-left font-body-sm text-body-sm font-semibold transition-colors ${
                  active === s.key
                    ? "bg-primary/10 text-primary dark:bg-primary/20 dark:text-primary-fixed-dim"
                    : "text-on-surface-variant hover:bg-surface-container-high dark:hover:bg-white/[0.05]"
                }`}
              >
                <Icon name={s.icon} className="text-[18px]" />
                {s.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
